let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2xxue")).then(() => parcelRequire('ffSG0'));